import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  icon?: boolean;
  href?: string;
  size?: 'default' | 'lg';
}
export function Button({
  children,
  variant = 'primary',
  icon = false,
  size = 'default',
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 ease-out rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#A88B9D]';
  const sizeStyles = {
    default: 'px-8 py-4 text-base',
    lg: 'px-10 py-5 text-lg'
  };
  const variants = {
    primary: 'bg-[#A88B9D] text-white hover:bg-[#8B7082] shadow-md hover:shadow-lg',
    secondary: 'bg-[#4A3B47] text-[#FBF9F7] hover:bg-[#5D4A58]',
    outline: 'border-2 border-[#A88B9D] text-[#A88B9D] hover:bg-[#A88B9D] hover:text-white'
  };
  const content = <>
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-99" />}
    </>;
  if (href) {
    return <motion.a href={href} className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-100">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseStyles} ${sizeStyles[size]} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-101">
      {content}
    </motion.button>;
}